/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Search_Modal_ClaimInputs */

const en_domain_search_modal_claim = /** @type {(inputs: Domain_Search_Modal_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim`)
};

const es_domain_search_modal_claim = /** @type {(inputs: Domain_Search_Modal_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclamar`)
};

const fr_domain_search_modal_claim = /** @type {(inputs: Domain_Search_Modal_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réclamer`)
};

const de_domain_search_modal_claim = /** @type {(inputs: Domain_Search_Modal_ClaimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beanspruchen`)
};

/** @type {(inputs: Domain_Search_Modal_ClaimInputs) => LocalizedString} */
const ja_domain_search_modal_claim = en_domain_search_modal_claim;

/** @type {(inputs: Domain_Search_Modal_ClaimInputs) => LocalizedString} */
const zh_domain_search_modal_claim = en_domain_search_modal_claim;

/** @type {(inputs: Domain_Search_Modal_ClaimInputs) => LocalizedString} */
const ar_domain_search_modal_claim = en_domain_search_modal_claim;

/** @type {(inputs: Domain_Search_Modal_ClaimInputs) => LocalizedString} */
const id_domain_search_modal_claim = en_domain_search_modal_claim;

/** @type {(inputs: Domain_Search_Modal_ClaimInputs) => LocalizedString} */
const it_domain_search_modal_claim = en_domain_search_modal_claim;

/** @type {(inputs: Domain_Search_Modal_ClaimInputs) => LocalizedString} */
const ru_domain_search_modal_claim = en_domain_search_modal_claim;

/** @type {(inputs: Domain_Search_Modal_ClaimInputs) => LocalizedString} */
const pt_domain_search_modal_claim = en_domain_search_modal_claim;

/** @type {(inputs: Domain_Search_Modal_ClaimInputs) => LocalizedString} */
const ko_domain_search_modal_claim = en_domain_search_modal_claim;

/**
* | output |
* | --- |
* | "Claim" |
*
* @param {Domain_Search_Modal_ClaimInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_claim = /** @type {((inputs?: Domain_Search_Modal_ClaimInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_ClaimInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_claim(inputs)
	if (locale === "es") return es_domain_search_modal_claim(inputs)
	if (locale === "fr") return fr_domain_search_modal_claim(inputs)
	if (locale === "de") return de_domain_search_modal_claim(inputs)
	if (locale === "ja") return ja_domain_search_modal_claim(inputs)
	if (locale === "zh") return zh_domain_search_modal_claim(inputs)
	if (locale === "ar") return ar_domain_search_modal_claim(inputs)
	if (locale === "id") return id_domain_search_modal_claim(inputs)
	if (locale === "it") return it_domain_search_modal_claim(inputs)
	if (locale === "ru") return ru_domain_search_modal_claim(inputs)
	if (locale === "pt") return pt_domain_search_modal_claim(inputs)
	return ko_domain_search_modal_claim(inputs)
});